import React from "react";
import { ThemeProvider } from "styled-components";
import { theme } from 'services/shared/StyledComponents'

export default ({ children }) => (
  <ThemeProvider theme={theme}>
    <>{children}</>
  </ThemeProvider>
);